import { ChallengeCard } from "../challenge/ChallengeView.interface";

export interface FeedItem {
  itemId: string;
  publishedAt: string;
  topic: string;
  title: string;
  imgUrl: string;
  tags: Array<string>;
  introText: string;
  targetUrl: string;
  type: "blog";
}

interface DailyAction {
  actionTitle: string;
  challengeTitle: string;
  tags: Array<string>;
  imgUrl: string;
  targetUrl: string;
  reminderText?: string;
  reminderTime: string;
}

interface DailyActionGroup {
  chapterName: string;
  actions: Array<DailyAction>;
}
interface DailyActionsView {
  todayActions: Array<DailyActionGroup>;
  tomorrowActions: Array<DailyActionGroup>;
  thisWeekActions: Array<DailyActionGroup>;
  thisMonthActions: Array<DailyActionGroup>;
  dailyChallengeLabel: string;
  chapterLabel: string;
  todayLabel: string;
  tomorrowLabel: string;
  emptyMessage: {
    title: string;
    description: string;
  };
}

interface RecommendedChallengesView {
  challenges: Array<ChallengeCard>;
  recommendedLabel: string;
}

interface FeedView {
  feedItems: Array<FeedItem>;
  feedLabel: string;
}

interface HeaderView {
  pageTitle: string;
  zenPoints: number;
  zenPointsLabel: string;
  darePointsLabel: string;
}
interface HomeView {
  header: HeaderView;
  feed: FeedView;
  actions: DailyActionsView;
  recommendations: RecommendedChallengesView;
}

const defaultHomeView: HomeView = {
  header: undefined,
  actions: undefined,
  recommendations: undefined,
  feed: undefined,
};

export {
  HomeView,
  HeaderView,
  RecommendedChallengesView,
  DailyActionsView,
  FeedView,
  DailyActionGroup,
  DailyAction,
  defaultHomeView,
};
